module.exports = __webpack_public_path__ + "static/media/18ECA25.f2bdd1a7.jpg";